import { render } from "./EventsPage.vue?vue&type=template&id=37aeada2"
import script from "./EventsPage.vue?vue&type=script&lang=js"
export * from "./EventsPage.vue?vue&type=script&lang=js"

import "./EventsPage.vue?vue&type=style&index=0&id=37aeada2&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__